<style>
   .it {
        width           : 450px;
        display         : flex;
        flex-direction  : column;
        justify-content : center;
        align-content   : center;
        margin          : 1em;
        color           : white;
    }

    .it > div {
        margin-bottom: 1em;
    }

    .ui.label {
        width: 120px;
        background-color: #fff;
        border-right: 1px solid #ddd;
    }

    .optin label {
        font-size: 12pt;
    }

    button {
        margin-top: 2em !important;
    }
</style>

<script>
    import _        from 'lodash'
    import { post } from './shared/api'
    import saveAs   from 'file-saver'

    let name     = '' 
    let email    = '' 
    let company  = ''
    let promo    = ''
    let message  = ''
    let optin    = false
    let loading  = false
    let error    = false
    let done     = false

    $: companyValid = company === '' || /\w{2,}/.test(company)
    $: nameValid    = name    === '' || /\w{2,}/.test(name)
    $: emailValid   = email   === '' || /^\w+([\.\+-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)
    $: promoValid   = promo   === '' || /\w{4,}/.test(promo)
    $: allowed      = name && nameValid && email && emailValid && company && companyValid && promoValid

    function register() {
        loading = true
        return post('/invite', _.omitBy({ company, name, email, optin, promo }, i => i === ''))
            .then(res => {
                loading = false
                if(res.status === 200) {
                    const ctype       = res.headers.get('Content-Type')
                    const disposition = res.headers.get('Content-Disposition')
                    if(ctype === 'application/json') {
                        res.json().then(console.log)
                    } else {
                        res.blob().then(blob => {
                            saveAs(blob, 'mapeamento-de-dados-dogma-v1.xls')
                        })
                    }
                    done = true
                } else if(res.status === 404 /* Not Found */) {
                    /* bad promo code */
                    error   = true
                    message = 'Código promocional não encontrado'
                } else {
                    error   = true
                    message = 'Erro ao cadastrar'
                }
            })
            .catch(err => {
                loading = false
                error   = true
                message = 'Erro'
                console.log(err)
            })
    }
</script>

<div class="it">
    {#if done}
        <h3>Obrigado!</h3>
    {:else}
        <div class="ui labeled big input {companyValid ? '' : 'error'}" 
            class:disabled={loading || error}>
            <div class="ui label">Empresa</div>
            <input  bind:value={company} 
                    placeholder=""
                    autocomplete="false">
        </div>
        <div class="ui labeled big input {nameValid ? '' : 'error'}" 
            class:disabled={loading || error}>
            <div class="ui label">Nome</div>
            <input  bind:value={name} 
                    placeholder=""
                    autocomplete="false">
        </div>
        <div class="ui labeled big input {emailValid ? '' : 'error'}" 
            class:disabled={loading || error}>
            <div class="ui label">Email</div>
            <input  bind:value={email} 
                    placeholder=""
                    autocomplete="false">
        </div>
        <div class="ui labeled big input {promoValid ? '' : 'error'}" 
            class:disabled={loading || error}>
            <div class="ui label">Código</div>
            <input  bind:value={promo} 
                    placeholder="LGPD2020"
                    autocomplete="false">
        </div>
        <div class="ui toggle big checkbox optin"
            class:disabled={loading || error}>
            <input type="checkbox" bind:checked={optin}>
            <label style="color: white !important">Autorizo o recebimento de emails sobre os produtos e serviços oferecidos pela Dogma</label>
        </div>

        {#if error}
            <h3 style="text-align: right;">{message}</h3>
        {:else}
            <button class="ui big blue button" 
                    on:click={register} 
                    class:loading
                    class:disabled={!allowed || loading || error}>
                Baixar a Planilha
            </button>
        {/if}
    {/if}
</div>